function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Button } from '@zillow/constellation';
import { sendSellerShowcaseInteractionEvent } from './utils/analytics';

var getRedirectUrl = function getRedirectUrl(currentUrl, urlPath, addQueryParams) {
  var newUrl = new URL("" + currentUrl.origin + urlPath);

  if (addQueryParams) {
    var currentParams = new URLSearchParams(currentUrl.search);
    currentParams.forEach(function (value, key) {
      newUrl.searchParams.append(key, value);
    });
  }

  return newUrl.toString();
};

var ButtonRedirect = function ButtonRedirect(props) {
  var currentUrlPath = props.currentUrlPath,
      _props$redirectUrlPat = props.redirectUrlPath,
      redirectUrlPath = _props$redirectUrlPat === void 0 ? '' : _props$redirectUrlPat,
      label = props.label,
      triggerSource = props.triggerSource,
      _props$addQueryParams = props.addQueryParams,
      addQueryParams = _props$addQueryParams === void 0 ? true : _props$addQueryParams,
      _props$openInNewTab = props.openInNewTab,
      openInNewTab = _props$openInNewTab === void 0 ? false : _props$openInNewTab;

  if (!currentUrlPath) {
    return null;
  }

  var onClick = function onClick() {
    var currentUrl = new URL(currentUrlPath);
    var zpid = currentUrl.searchParams.get('zpid');
    var redirectUrl = getRedirectUrl(currentUrl, redirectUrlPath, addQueryParams);

    if (redirectUrl) {
      sendSellerShowcaseInteractionEvent(triggerSource, zpid);

      if (openInNewTab) {
        window.open(redirectUrl, '_blank');
      } else {
        window.location.assign(redirectUrl);
      }
    }
  };

  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    onClick: onClick
  }), label);
};

export default ButtonRedirect;
//# sourceMappingURL=ButtonRedirect.js.map